import { WabunkaExperienceEventReservationType } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_event_reservation_type';

export const reservationStepLabels = ['Details', 'Review', 'Requested', 'Confirmed'] as const;
export type ReservationStepLabels = (typeof reservationStepLabels)[number];

export const stepsBuilder = (currentReservationStepLabel: ReservationStepLabels, reservationType?: WabunkaExperienceEventReservationType) => {
  const isInstantReservation = reservationType === WabunkaExperienceEventReservationType.EXPERIENCE_EVENT_RESERVATION_TYPE_INSTANT;

  // 即時予約: Details → Review → Confirmed (3ステップ)
  // リクエスト予約: Details → Review → Requested → Confirmed (4ステップ)

  switch (currentReservationStepLabel) {
    case 'Details':
      return [
        { label: 'Details', link: '', done: false, active: true },
        { label: 'Review', link: '', done: false, active: false },
        ...(isInstantReservation ? [] : [{ label: 'Requested', link: '', done: false, active: false }]),
        { label: 'Confirmed', link: '', done: false, active: false },
      ];

    case 'Review':
      return [
        { label: 'Details', link: '', done: true, active: true },
        { label: 'Review', link: '', done: false, active: true },
        ...(isInstantReservation ? [] : [{ label: 'Requested', link: '', done: false, active: false }]),
        { label: 'Confirmed', link: '', done: false, active: false },
      ];

    case 'Requested':
      return [
        { label: 'Details', link: '', done: true, active: false },
        { label: 'Review', link: '', done: true, active: false },
        { label: 'Requested', link: '', done: true, active: true },
        { label: 'Confirmed', link: '', done: false, active: false },
      ];

    case 'Confirmed':
      return [
        { label: 'Details', link: '', done: true, active: false },
        { label: 'Review', link: '', done: true, active: false },
        ...(isInstantReservation ? [] : [{ label: 'Requested', link: '', done: true, active: false }]),
        { label: 'Confirmed', link: '', done: true, active: true },
      ];

    default:
      return [
        { label: 'Details', link: '', done: false, active: false },
        { label: 'Review', link: '', done: false, active: false },
        ...(isInstantReservation ? [] : [{ label: 'Requested', link: '', done: false, active: false }]),
        { label: 'Confirmed', link: '', done: false, active: false },
      ];
  }
};
